import { render, staticRenderFns } from "./smartLabel.vue?vue&type=template&id=e9dbe7bc&scoped=true&"
import script from "./smartLabel.vue?vue&type=script&lang=js&"
export * from "./smartLabel.vue?vue&type=script&lang=js&"
import style0 from "./smartLabel.vue?vue&type=style&index=0&id=e9dbe7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9dbe7bc",
  null
  
)

export default component.exports